export const PRODUCTS_DOMAIN = 'app/modules/Contents/PRODUCTS_DOMAIN';
export const REQUEST_PRODUCTS = 'app/modules/Contents/REQUEST_PRODUCTS';
export const REQUEST_CREATE_PRODUCT = 'app/modules/Contents/REQUEST_CREATE_PRODUCT';
export const REQUEST_PRODUCT = 'app/modules/Contents/REQUEST_PRODUCT';
export const REQUEST_PRODUCTS_BY_INVOICE = 'app/modules/Contents/REQUEST_PRODUCTS_BY_INVOICE';
export const REQUEST_PRODUCT_SEARCH = 'app/modules/Contents/REQUEST_PRODUCT_SEARCH';
export const REQUEST_UPDATE_PRODUCT = 'app/modules/Contents/REQUEST_UPDATE_PRODUCT';
export const REQUEST_PRODUCT_COMPANY_FIN_DATA = 'app/modules/Contents/REQUEST_PRODUCT_COMPANY_FIN_DATA';
export const REQUEST_UPDATE_PRODUCT_COMPANY_FIN_DATA = 'app/modules/Contents/REQUEST_UPDATE_PRODUCT_COMPANY_FIN_DATA';
export const INITIATE_PRODUCT_EDIT = 'app/modules/Contents/REQUEST_INITIATE_PRODUCT_EDIT';
export const REQUEST_PRODUCTS_FILTER = 'app/modules/Contents/REQUEST_PRODUCTS_FILTER';
export const REQUEST_PRODUCT_DOWNLOAD = 'app/modules/Contents/REQUEST_PRODUCT_DOWNLOAD';
export const REQUEST_GET_COUNTERS = 'app/modules/Contents/REQUEST_GET_COUNTERS';
export const FILTER_DEFAULT_LIMIT = 50;

export const SET_NEW_PRODUCT_VALUE = 'app/modules/Contents/SET_NEW_PRODUCT_VALUE';

export const REQUEST_CREATE_PRODUCT_CUSTOM_FIN_DATA = 'app/modules/Contents/REQUEST_CREATE_PRODUCT_CUSTOM_FIN_DATA';

export const REQUEST_COMPANY_PRODUCT = 'app/modules/Contents/REQUEST_COMPANY_PRODUCT';
export const REQUEST_COMPANY_PRODUCTS = 'app/modules/Contents/REQUEST_COMPANY_PRODUCTS';
export const REQUEST_COMPANY_PRODUCTS_FILTER = 'app/modules/Contents/REQUEST_COMPANY_PRODUCTS_FILTER';
export const REQUEST_COMPANY_PRODUCTS_IDS = 'app/modules/Contents/REQUEST_COMPANY_PRODUCTS_IDS';
export const REQUEST_ADD_COMPANY_PRODUCT = 'app/modules/Contents/REQUEST_ADD_COMPANY_PRODUCT';
export const REQUEST_DELETE_COMPANY_PRODUCT = 'app/modules/Contents/REQUEST_DELETE_COMPANY_PRODUCT';
export const REQUEST_ADD_COMPANY_PRODUCT_CUSTOMIZATION = 'app/modules/Contents/REQUEST_ADD_COMPANY_PRODUCT_CUSTOMIZATION';
export const REQUEST_UPDATE_COMPANY_PRODUCT_CUSTOMIZATION = 'app/modules/Contents/REQUEST_UPDATE_COMPANY_PRODUCT_CUSTOMIZATION';
export const REQUEST_DELETE_COMPANY_PRODUCT_CUSTOMIZATION = 'app/modules/Contents/REQUEST_DELETE_COMPANY_PRODUCT_CUSTOMIZATION';

export const REQUEST_GET_ALL_PRODUCT_TASKS = 'app/modules/Contents/REQUEST_GET_ALL_PRODUCT_TASKS';
export const REQUEST_GET_PRODUCT_TASKS = 'app/modules/Contents/REQUEST_GET_PRODUCT_TASKS';
export const REQUEST_ADD_PRODUCT_TASK = 'app/modules/Contents/REQUEST_ADD_PRODUCT_TASK';
export const REQUEST_DELETE_PRODUCT_TASK = 'app/modules/Contents/REQUEST_DELETE_PRODUCT_TASK';


export const PRODUCT_STATUS = {
  ACTIVE: '0',
  DEACTIVE: '1',
  DELETED: '2',
}
